import FontAwesomeIcon from '@components/atoms/fontAwesomeIcon';

import { BreadcrumbsStyle } from './style';

type Props = {
  breadcrumbs: JSX.Element[];
  widthLastList?: string;
  color?: string;
};

export default function CustomSeparator({ breadcrumbs, widthLastList = '70%', color = undefined }: Props) {
  return (
    <BreadcrumbsStyle
      widthLastList={widthLastList}
      isRemoveLastList={breadcrumbs.length >= 3}
      separator={<FontAwesomeIcon style={{ color, margin: '0 0.5rem' }} icon="fa-light fa-angle-right" />}
      aria-label="breadcrumb"
    >
      {breadcrumbs}
    </BreadcrumbsStyle>
  );
}
